<div [ngClass]="env && env !== 'PROD' ? 'component' : ''">
	<div class="app">
		<div class="hallmark"></div>
		<div class="brand-copy">
			<h2 class="title">{{ title }} <span *ngIf="env && env !== 'PROD'">[{{ env }}]</span></h2>
			<p class="subtitle">Monthly Reliability Risk Report Tracker</p>
		</div>
	</div>
	<div *ngIf="appSettings.user" class="user">
		<span class="guide icon" [title]="guideIconTitle" aria-label="Guide" (click)="navigateTo('/guide')">help</span>
		<div class="welcome">Welcome<br /><span>{{ appSettings.user.name }}</span></div>
		<div class="profile">
			<img *ngIf="showPhoto" [src]="appSettings.user.photo" (error)="showPhoto = false" height="100%" [alt]="appSettings.user.name" title="User profile photo">
			<div class="initials">{{ appSettings.user.initials }}</div>
		</div>
	</div>
</div>
